import { toast } from "react-toastify";
 export  const notificationToastSuccess=(res)=>{toast.success(res,{autoClose: 4000, pauseOnFocusLoss:false})};
 export  const notificationToastError=(res)=>toast.error(res,{autoClose: 4000, pauseOnFocusLoss:false})
